import {ref, onMounted, onUnmounted} from "vue";

const POSTER_WIDTH = 840;

export function usePosterScale() {
  const scale = ref(1);
  function update() {
    scale.value = Math.min(1, window.innerWidth / POSTER_WIDTH);
  }
  onMounted(() => {
    update();
    window.addEventListener("resize", update);
  });
  onUnmounted(() => window.removeEventListener("resize", update));
  return scale;
}
